
import { z } from "zod";

export const FundingPaymentMethodValues = ["LOAN", "UP_FRONT"] as const;
export const FundingPaymentMethodSchema = /* @__PURE__ */ z.enum(FundingPaymentMethodValues);
export const FundingPaymentMethod: (typeof FundingPaymentMethodSchema)["enum"] = { "LOAN": "LOAN", "UP_FRONT": "UP_FRONT" };
export type FundingPaymentMethod = (typeof FundingPaymentMethodValues)[number];
export const FundingPaymentMethodDisplayNames = { "LOAN": "Pay over time",
"UP_FRONT": "Pay up front", } satisfies Record<FundingPaymentMethod, string>;
